import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { FinancialConnectionStatus } from '@40seas/entities/financial-connections';
import { BusinessMatch, BusinessMatchSchema } from '@40seas/entities/match';
import { Currency } from '@40seas/models';
import { z } from 'zod';

export const CreditReviewBankAccountOwnershipSchema = z
    .object({
        match: BusinessMatchSchema.nullish(),
        name: z.string(),
    })
    .strict();

export class CreditReviewBankAccountOwnership extends FromSchema(CreditReviewBankAccountOwnershipSchema) {
    match?: BusinessMatch;
    name: string;
}

export const CreditReviewBankAccountBalanceSchema = z
    .object({
        amount: z.number(),
        currency: EnumSchema(Currency),
    })
    .strict();

export class CreditReviewBankAccountBalance extends FromSchema(CreditReviewBankAccountBalanceSchema) {
    amount: number;
    currency: Currency;
}

export const CreditReviewBankAccountSchema = z
    .object({
        accountName: z.string(),
        ownership: CreditReviewBankAccountOwnershipSchema,
        balance: CreditReviewBankAccountBalanceSchema,
        status: EnumSchema(FinancialConnectionStatus),
        numberOfTransactions: z.number(),
    })
    .strict();

export class CreditReviewBankAccount extends FromSchema(CreditReviewBankAccountSchema) {
    accountName: string;
    ownership: CreditReviewBankAccountOwnership;
    balance: CreditReviewBankAccountBalance;
    status: FinancialConnectionStatus;
    numberOfTransactions: number;
}
